(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach(
            (el) => {
              [...el.classList]
                .filter((cl) => cl.indexOf('disclosure') === 0)
                .forEach((cl) => {
                  el.classList.remove(cl);
                  el.classList.add(`mobile-${cl}`);
                });
            }
          );
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll(
            '.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content'
          ).forEach((el) => {
            [...el.classList]
              .filter((cl) => cl.indexOf('mobile-disclosure') === 0)
              .forEach((cl) => {
                el.classList.remove(cl);
                el.classList.add(cl.substr(7));
              });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  // Original product recommendations loading function
  var loadProductRecommendationsIntoSection = function() {
    var productRecommendationsSection = document.querySelector(".related-products");
    if (productRecommendationsSection === null) { return; }

    var request = new XMLHttpRequest();
    request.open("GET", productRecommendationsSection.dataset.url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;

        // After content is loaded, initialize the carousel
        initRelatedProductsSwiper();
      }
    };
    request.send();
  };

  // Load Swiper library if not already loaded
  function loadSwiperLibrary() {
    return new Promise(function(resolve) {
      if (typeof Swiper !== 'undefined') {
        resolve();
        return;
      }

      // Load Swiper CSS
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      document.head.appendChild(link);

      // Load Swiper JS
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      script.onload = function() {
        resolve();
      };
      document.head.appendChild(script);
    });
  }

  // Initialize Swiper carousel with retry
  function initRelatedProductsSwiper(attempts = 0) {
    if (attempts > 5) return;

    var container = document.querySelector('.related-products .swiper-container');
    if (!container) {
      setTimeout(function() {
        initRelatedProductsSwiper(attempts + 1);
      }, 200);
      return;
    }

    if (typeof Swiper === 'undefined') {
      loadSwiperLibrary().then(function() {
        initSwiperCarousel(container);
      });
    } else {
      initSwiperCarousel(container);
    }
  }

  // Create the actual Swiper instance
  function initSwiperCarousel(container) {
    try {
      new Swiper(container, {
        slidesPerView: 2,
        spaceBetween: 10,
        grabCursor: true,
        pagination: {
          el: '.related-products .swiper-pagination',
          clickable: true,
          dynamicBullets: false,
        },
        navigation: {
          nextEl: '.related-products .swiper-button-next',
          prevEl: '.related-products .swiper-button-prev'
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: parseInt('{{ section.settings.grid }}', 10) || 4,
            spaceBetween: 20
          }
        }
      });
    } catch (e) {
      console.error("Error initializing Swiper:", e);
    }
  }

  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  // Fetch when section reloads in editor
  document.addEventListener("shopify:section:load", function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
      loadProductRecommendationsIntoSection();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
